module.exports = window.jQuery || (window.$ = window.jQuery = require('jquery'));